module.exports = __webpack_public_path__ + "static/media/FT_L_P3.b2cc21e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/wounds/FT_L_P3.png
// module id = 2229
// module chunks = 0